import * as ApiHelper from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

interface EndpointResponse {
  successfullyAdded: number;
  productAmount: number;
}

export function sendData(override: boolean, saleOnly: boolean): Promise<EndpointResponse> {
  const apiUrl = resolveApiUrl(`/bulkupload/addToCart?override=${override}&saleOnly=${saleOnly}`);

  const params: RequestInit = {
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  };

  return (
    fetch(apiUrl, params)
      .then((res) => res.json())
      // TODO - Fix 2026.04
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((json: any) => {
        if (json.noLines !== undefined) {
          return {
            successfullyAdded: json.noLines || 0,
            productAmount: json.productAmount || 0,
            errors: [],
          };
        } else {
          const error = json as { reason: string; params: string[] };
          return {
            successfullyAdded: 0,
            productAmount: 0,
            errors: [error],
          };
        }
      })
  );
}
